import { combineReducers } from '@reduxjs/toolkit'
import user from './user/reducers'
import menu from './menu/reducers'
import appsettings from './appsettings/reducers'
import settings from './settings/reducers'
import etc from './etc/reducers'
import mailExport from './mailExport/reducers'
import maintenance from './maintenance/reducers'

export default () =>
  combineReducers({
    user,
    menu,
    appsettings,
    settings,
    etc,
    mailExport,
    maintenance,
  })
